import React, { useEffect, useState } from "react"
import { Link, useHistory, withRouter } from "react-router-dom"
import {
  Col,
  Container,
  Row,
  Table,
  Label,
  UncontrolledTooltip,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from "reactstrap"

//Import Component
import Breadcrumbs from "components/Common/Breadcrumb"

import axios from "axios"
import PaginationComponent from "common/PaginationComponent"
import { convertPermission } from "permissionUtils"
import UnAuthorizedComponent from "common/UnAuthorizedComponent"
import FilterStatusHistory from "./FilterStatusHistory"
import { usePrevious } from "common/CustomHooks"
import NewSessionResults from "../BaladiiStatus/NewSessionResults"
import LoadingComponent from "common/LoadingComponent"
import LoadingInsider from "common/LoadingInsider"

const BaladiHistory = () => {
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [viewloading, setViewLoading] = useState(false)
  const [historyList, setHistoryList] = useState([])

  // **************** Permissions ******************************
  const userPermissions = convertPermission(
    JSON.parse(localStorage.getItem("roles"))
  )
  // console.log("userPermissions", userPermissions)

  // **************** Authorization ******************************
  const [auth, setAuth] = useState(false)

  // **********pagination *********************
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)

  // ************************** View Modal *****************************
  const [statusResults, setStatusResults] = useState([])
  const [batchDetails, setBatchDetails] = useState()
  const getStatusResults = batchID => {
    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      BatchID: batchID,
    }

    axios
      .post(
        process.env.REACT_APP_API_URL + `api/BaladyDetails/View.php`,
        formData
      )
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        // console.log("res.data", res.data)

        setBatchDetails(res.data.BatchDetails)

        let arrayKeys = Object.keys(res.data.StatusResults)
        // console.log("arrayKeys", arrayKeys)

        let results = arrayKeys.map(key => ({
          name: key,
          results: res.data.StatusResults[key],
        }))

        results = results.filter(result => result.results.length > 0)

        // console.log("results", results)

        setStatusResults(results)
        setViewLoading(false)
      })
      .catch(err => {
        console.log(err)
      })
  }

  const [viewModal, setViewModal] = useState(false)
  const viewReportHandler = report => {
    setViewLoading(true)
    setViewModal(true)
    getStatusResults(report.BatchID)
  }

  // ************************** Filter section *****************************
  const initialFilteredValues = {
    StartDate: "",
    EndDate: "",
    User: [],
  }
  const [filteredValues, setFilteredValues] = useState(initialFilteredValues)
  // console.log("filteredValues=========>", filteredValues)
  const prevFilteredValues = usePrevious(filteredValues)

  useEffect(() => {
    if (JSON.stringify(prevFilteredValues) !== JSON.stringify(filteredValues)) {
      setPage(1)
    }

    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      Page: page,
      StartDate: filteredValues.StartDate,
      EndDate: filteredValues.EndDate || filteredValues.StartDate,
      UserID: filteredValues.User.map(item => item.value).join(","),
    }

    axios
      .post(
        process.env.REACT_APP_API_URL + `api/BaladyDetails/History.php`,
        formData
      )
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        // console.log(res.data)
        setTotalPages(res.data.TotalPages)
        let resArray = Object.values(res.data)

        // Removing page number info from the array
        resArray.splice(-4)
        // console.log("resArray", resArray)
        setHistoryList(resArray)
        setTimeout(() => {
          setLoading(false)
        }, 2000)
      })
      .catch(err => {
        console.log(err)
      })
  }, [filteredValues, page])

  // Access denied !!
  if (auth) {
    return <UnAuthorizedComponent />
  }

  // not allowed views
  if (
    userPermissions.R3.P !== "1" &&
    userPermissions.R3.P !== "2" &&
    userPermissions.R3.P !== "3" &&
    userPermissions.R3.P !== "4" &&
    userPermissions.R3.G !== "1"
  )
    return (
      <div className="page-content">
        <h3 className="d-flex justify-content-center p-3 text-light bg-danger">
          You are not authenticated!!
        </h3>
      </div>
    )
  else {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="Baladi" breadcrumbItem="Status History" />

            {!viewModal ? (
              <>
                {/* ***************** Filter Section ************************* */}
                <Row>
                  <FilterStatusHistory
                    filteredValues={filteredValues}
                    setFilteredValues={setFilteredValues}
                    setAuth={setAuth}
                  />
                </Row>

                <Row>
                  <Col lg="12">
                    <div className="">
                      <div className="table-responsive">
                        {/******************* table section**************************/}
                        <Table className="project-list-table table-nowrap align-middle table-borderless">
                          <thead>
                            <tr>
                              <th scope="col" style={{ width: "20px" }}>
                                #
                              </th>
                              <th scope="col">User</th>
                              <th scope="col">Date</th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          {/***********table body *****************/}
                          <tbody>
                            {historyList.map((item, key) => (
                              <tr key={key}>
                                <td>
                                  <input
                                    type="checkbox"
                                    onClick={() => {
                                      checkbox(item)
                                    }}
                                    className="form-check-input  p-1 border-primary"
                                  />
                                </td>

                                <td>{item.Name}</td>

                                <td>{item.CreatedAt}</td>

                                <td>
                                  <Button
                                    // color="primary"
                                    className="btn btn-primary btn-sm dropdown-toggle"
                                    onClick={() => {
                                      viewReportHandler(item)
                                    }}
                                  >
                                    View
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </Col>
                </Row>

                {/* ********************** Pagination ********************************* */}
                {totalPages > 1 && (
                  <Row>
                    <PaginationComponent
                      page={page}
                      setPage={setPage}
                      totalPages={totalPages}
                      setTotalPages={setTotalPages}
                    />
                  </Row>
                )}
              </>
            ) : viewloading ? (
              <LoadingInsider type="spin" color="gray" />
            ) : (
              <NewSessionResults
                type={"history"}
                statusResults={statusResults}
                batchDetails={batchDetails}
                setViewModal={setViewModal}
              />
            )}
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

export default BaladiHistory
